module.exports = __webpack_public_path__ + "static/media/death.5458fe92.webp";